import { render, staticRenderFns } from "./WatchlistAddPopup.vue?vue&type=template&id=4775b827"
import script from "./WatchlistAddPopup.vue?vue&type=script&lang=js"
export * from "./WatchlistAddPopup.vue?vue&type=script&lang=js"
import style0 from "./WatchlistAddPopup.vue?vue&type=style&index=0&id=4775b827&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports